import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({ selector: '[appTapClick]' })
export class TapClickDirective {
  @Input('appTapClick') enabled = true;

  constructor(private el: ElementRef<HTMLElement>) {}

  // Forward touchend -> click on host element for short taps.
  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent) {
    if (!this.enabled) return;
    try {
      // only handle single-finger touches
      if (!event.changedTouches || event.changedTouches.length === 0) return;
      console.log("as");
      
      const click = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
      this.el.nativeElement.dispatchEvent(click);
    } catch (err) {
      // ignore errors
    }
  }
}
